import { Column, ColumnKeys } from './grid';
import { GridViewMetadata } from '../../../grid/gridView/types';
import { SelectOption } from '../../../ui/gzSelect/types';
import { Filter } from '../../../grid/gridFilters/types';

export * from './grid';
export * from '../../types/package-data';
export * from './package-type';
export * from './package-type-data';

export interface PackagesWebComponentSchema {
  viewMetaData: GridViewMetadata<Column, ColumnKeys>;
  defaultViewProps: DefaultViewProps;
}

export interface DefaultViewProps {
  displayedColumns: Array<Column>;
  filters: Array<Filter<ColumnKeys>>;
  pageSize: number;
  compactView: boolean;
}

export interface Permissions {
  canHaveChildCompanies: boolean;
  canManagePlatform: boolean;
}

export interface PackageLinksData {
  'kit-bstnix': string;
  'kit-bstwin': string;
  'kit-mac': string;
  'kit-mac-arm': string;
  'kit-mac-downloader': string;
}

export interface PackageCompanySettingsData {
  hasContainerProtectionUsable: boolean;
}

export enum SelectableAction {
  DOWNLOAD_MORE_ACTIONS = '1',
  DELETE_MORE_ACTIONS = '2',
}

export enum CompanyEndpointMethod {
  GET_AVAILABLE_COMPANIES = 'getAvailableCompanies',
}

export interface AvailableCompaniesResponse {
  data: Array<AvailableCompany>;
}

export interface AvailableCompany {
  name: string;
  _id: string;
}

export enum PackagesEndpointMethod {
  READ_RECORDS = 'readRecords',
  CREATE_RECORDS = 'createRecords',
  UPDATE_RECORDS = 'updateRecords',
  REMOVE_RECORDS = 'removeRecords',
  GET_PACKAGE_LINKS = 'getPackageLinks',
  SEND_LINKS_BY_EMAIL = 'sendLinksByEmail',
  GET_PACKAGE_BY_ID = 'getPackageById',
  GET_COMPANY_PACKAGES = 'getCompanyPackages',
}

export enum FeatureManagerEndpointMethod {
  GET_FEATURES_BY_COMPANY = 'getFeaturesByCompany',
}

export enum PackageNameMappings {
  DEFAULT_UPDATE_SERVER_PACKAGE = 'Default Update Server Package',
  DEFAULT_SECURITY_SERVER_PACKAGE = 'Default Security Server Package',
  DEFAULT_BDTOOLS_PACKAGE = 'Default BDTools Package',
  DEFAULT_ENDPOINT_SECURITY_PACKAGE = 'Default Endpoint Security Package',
  DEFAULT_SANDBOX_ANALYZER_PACKAGE = 'Default Sandbox Analyzer Package',
  DEFAULT_NETWORK_SECURITY_VIRTUAL_APPLIANCE_PACKAGE = 'Default Network Security Virtual Appliance Package',
  DEFAULT_NETWORK_SENSOR_VIRTUAL_APPLIANCE = 'Default Network Sensor Virtual Appliance Package',
  FREE_RISK_ASSESSMENT_TOOL_PACKAGE = 'Free Risk Assessment Tool Package',
  FREE_RISK_ASSESSMENT_TOOLS_PACKAGE = 'Free Risk Assessment Tools Package',
  FREE_RISK_ASSESSMENT_TOOL_WITH_RELAY_PACKAGE = 'Free Risk Assessment Tool with Relay Package',
  FREE_RISK_ASSESSMENT_TOOLS_WITH_RELAY_PACKAGE = 'Free Risk Assessment Tools with Relay Package',
  DEFAULT_K8S_PACKAGE = 'Default Kubernetes Package',
}

export enum PackageNameMappingsHasManageCompanies {
  FREE_RISK_ASSESSMENT_TOOL_PACKAGE = 'Free Risk Assessment Tool Package',
  FREE_RISK_ASSESSMENT_TOOLS_PACKAGE = 'Free Risk Assessment Tools Package',
  FREE_RISK_ASSESSMENT_TOOL_WITH_RELAY_PACKAGE = 'Free Risk Assessment Tool with Relay Package',
  FREE_RISK_ASSESSMENT_TOOLS_WITH_RELAY_PACKAGE = 'Free Risk Assessment Tools with Relay Package',
}

export enum PackagePanelType {
  STAGING = 'staging',
  INSTALLATION_PACKAGES = 'installationPackages',
}
